<div class="page-preloader" [class.active]="active">
  <ng-lottie
    [options]="options"
    (animationCreated)="animationCreated($event)"
  ></ng-lottie>
</div>
